import { takeLatest } from 'redux-saga'
import {
	select,
	put,
	call,
} from 'redux-saga/effects'

import callAny from '../helpers/call_any'
import formatError from '../helpers/error_formatter'
import actionTypes from 'redux/actions/actionTypes'
import { iVideoCreationMcqActions } from 'redux/actions/interactiveVideoCreation'
import { interactiveVideoSync, questionSync } from 'sync'
import activityTypes from 'helpers/enums/activityTypes'
import { identitySelector } from 'redux/selectors/interactive_video_creation'
import { creationToolMcqSelector } from 'redux/selectors/creationTool'
import { saveInteractiveVideoActivity } from 'redux/sagas/interactive_video_creation_sagas'
import { mcqSave } from 'redux/sagas/creationTool/mcqSagas'

function *createMcqActivity(action) {
	try {
		if (!action.activityUid) {
			// This code is only executed when it's a new activity
			// When is not all this data will be already given in
			// the url

			const interactiveVideoIdentityData = yield select(identitySelector)

			const questionInitialData = {
				answers: [
					{
						text: '',
						correct: 0,
						order: 0,
					},
					{
						text: '',
						correct: 0,
						order: 1,
					},
				],
			}

			const newActivity = yield callAny(
				questionSync.create,
				interactiveVideoIdentityData.jwt,
				questionInitialData,
			)

			const breakpointActivity = yield callAny(
				interactiveVideoSync.addBreakpointActivity,
				interactiveVideoIdentityData.uid,
				interactiveVideoIdentityData.jwt,
				action.breakpointUid,
				newActivity.payload.uid,
				activityTypes.MULTIPLE_CHOICE_QUESTION
			)

			yield put(
				iVideoCreationMcqActions.createNewMcqActivitySuccess(
					newActivity.payload.uid,
					breakpointActivity.uid,
					newActivity.payload.answers.map(answer => answer.uid)
				)
			)
		}
	} catch (error) {
		const formattedError = formatError(error)
		yield put(iVideoCreationMcqActions.createNewMcqActivityError(
			formattedError
		))
	}
}

function *saveMcqInteractiveVideoActivity() {
	yield call(mcqSave)

	const activityData = yield select(creationToolMcqSelector)
	const isEdition = yield call(saveInteractiveVideoActivity, activityData.activityUid)

	return isEdition
}

function *save() {
	try {
		const isEdition = yield call(saveMcqInteractiveVideoActivity)

		yield put(
			iVideoCreationMcqActions.saveSuccess(isEdition)
		)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(iVideoCreationMcqActions.saveFailed(formattedError))
	}
}


export default [
	takeLatest([
		actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE,
		actionTypes.VIDEO_CREATION_MCQ_INITIALIZE,
		actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE,
	],
	createMcqActivity
	),
	takeLatest(
		actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE,
		save,
	),
]

export {
	createMcqActivity,
	saveMcqInteractiveVideoActivity,
}
